t = require('views/internal/teacup-with-helpers')('member_detail_profile_edit')

module.exports = ->
  t.p '.error.js-profile-form-error.hide'

  t.label ->
    t.format 'full-name'
  t.input { type: 'text', name: 'fullName', value: t.mustacheVar('fullName'), dir: 'auto', maxLength: 128 }

  t.label ->
    t.format 'username'
  t.input { type: 'text', name: 'username', value: t.mustacheVar('username'), maxLength: 100 }

  t.label ->
    t.format 'initials'
  t.input { type: 'text', name: 'initials', value: t.mustacheVar('initials'), maxLength: 8 }

  t.label ->
    t.format 'bio-optional'
  t.textarea { name: 'bio', dir: 'auto', maxLength: 16384 }, ->
    t.text t.mustacheVar('bio')

  t.input '.primary.wide.js-submit-profile', { type: 'submit', value: t.l('save') }
  t.input '.js-cancel-edit-profile', { type: 'button', value: t.l('cancel') }



// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_detail_profile_edit.coffee